import _get from 'lodash/get'
import _omitBy from 'lodash/omitBy'
import _isEmpty from 'lodash/isEmpty'
import request from '../request'
import { createAuthorization } from '../auth'
import { stringify } from '../query-string'

// Filters for the status dropdown
export const STATUS_FILTER_RESOLVED = 'STATUS_FILTER_RESOLVED'
export const STATUS_FILTER_UNRESOLVED = 'STATUS_FILTER_UNRESOLVED'

/*
* Options for 'action' + 'privilege' fields
* Duplicate from brooklyn - hydrate api in future
*/
export const MODERATOR_ACTIONS = {
  USER_PRIVILEGE_READWRITE: 'USER_PRIVILEGE_READWRITE',
  USER_PRIVILEGE_READONLY: 'USER_PRIVILEGE_READONLY',
  USER_PRIVILEGE_REVOKED: 'USER_PRIVILEGE_REVOKED',
  CONTENT_APPROVED: 'CONTENT_APPROVED',
  CONTENT_REJECTED: 'CONTENT_REJECTED',
}

/*
* Options for activity status
* Duplicate from brooklyn - hydrate api in future
*/
export const ACTIVITY_STATUS = {
  ACTIVITY_APPROVED: 'ACTIVITY_APPROVED',
  ACTIVITY_REJECTED: 'ACTIVITY_REJECTED',
  ACTIVITY_PENDING_REVIEW: 'ACTIVITY_PENDING_REVIEW',
}

/*
* Accusation Code
* Duplicate from brooklyn - api in future
*/
export const ACCUSATIONS = {
  MOD001: {
    title: 'Inappropriate Avatar',
    reason: 'This avatar contains nudity, gore, or other inappropriate imagery.',
  },
  MOD002: {
    title: 'Impersonation',
    reason: 'This profile is fake and does not seem to belong to the person they are claiming to be.',
  },
  MOD003: {
    title: 'Poor Conduct',
    reason: 'This member has sexually harassed, sent inappropriate messages, behaved in an abusive manner, bullied, or has bahaved disrespectfully towards you.',
  },
  MOD004: {
    title: 'Bad Videos',
    reason: 'This member has uploaded videos that violate Gaia\'s guidelines.',
  },
  MOD005: {
    title: 'Spammy',
    reason: 'This content includes misleading or deceptive links, or repetitive, irrelevant, or random text that seems designed primarily to drive traffic to third-party sites.',
  },
  MOD006: {
    title: 'Why We Are Here: Meaningful Connection, Support & Celebration',
    reason: 'The content flagged disempowers the community to share authentically and does not resonate with its purpose.',
  },
  MOD007: {
    title: 'This Is an Ad-Free Space',
    reason: 'The content flagged is using this space as a marketplace for transacting business.',
  },
  MOD008: {
    title: 'Safety',
    reason: 'The content flagged is a cause for alarm to someone\'s health or safety.',
  },
  MOD009: {
    title: 'Privacy & Prohibited Content',
    reason: 'The content flagged violates privacy rights or is prohibited by the terms of use of the site. See Gaia Terms of Use and Privacy Policy',
  },
  MOD010: {
    title: 'Member Service',
    reason: 'The content flagged is a member service request to be managed by the Community Relations team.',
  },
}

// Options for the moderator action dropdown
export const APPROVE_CONTENT = 'APPROVE_CONTENT'
export const REJECT_CONTENT = 'REJECT_CONTENT'
export const BAN_USER = 'BAN_USER'
export const ACTION_DROPDOWN_OPTIONS = [
  {
    label: 'Approve Content',
    value: APPROVE_CONTENT,
  },
  {
    label: 'Reject Content',
    value: REJECT_CONTENT,
  },
  {
    label: 'Reject Content + Ban User',
    value: BAN_USER,
  },
]

/*
* Fetch the User Moderation Report Groups
*/
export async function fetchUserModerationReports ({
  auth, server, filter, p = 0, pp = 10,
} = {}) {
  const resolved = filter === STATUS_FILTER_RESOLVED
  const query = stringify({
    resolved,
    p,
    pp,
  })
  const res = await request
    .get(`${server}/v1/user-moderation?${query}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return _get(res, 'body', { success: false })
}

/*
* Update a moderation report
*/
export async function updateUserModerationReport ({ auth, server, data } = {}) {
  let payload = data

  // If banning user, set privileges to be revoked
  if (payload.get('action') === BAN_USER) {
    payload = payload.set('privileges', MODERATOR_ACTIONS.USER_PRIVILEGE_REVOKED)
  }

  // If approving, force ommision of resolution code
  if (payload.get('action') === APPROVE_CONTENT) {
    payload = payload.delete('resolutionCode')
  }

  // Find the corresponding moderator action from the dropdown option
  payload = payload.set('action', {
    [APPROVE_CONTENT]: MODERATOR_ACTIONS.CONTENT_APPROVED,
    [REJECT_CONTENT]: MODERATOR_ACTIONS.CONTENT_REJECTED,
    [BAN_USER]: MODERATOR_ACTIONS.CONTENT_REJECTED,
  }[data.get('action')])

  // Remove falsey values
  payload = _omitBy(payload.toJS(), _isEmpty)

  const res = await request
    .put(`${server}/v1/user-moderation`)
    .send(payload)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')

  return res
}
